import { render, staticRenderFns } from "./PqPic.vue?vue&type=template&id=1752cd8c&"
import script from "./PqPic.vue?vue&type=script&lang=js&"
export * from "./PqPic.vue?vue&type=script&lang=js&"
import style0 from "./PqPic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports